export const NODE_REGISTRY = new Map();

export function reg(node) {
	NODE_REGISTRY.set(node.clazz, node);
}
